import React, { Suspense } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { useTranslation } from 'react-i18next';
import { ListItemButton } from '@wix/da-ds/pkg/List/ListItem';
import { BiData, SubscriberConnectToDiscordClickBiEvent } from '@wix/da-bi/pkg/events';
import DiscordModuleLoaderLazy from '../../../Discord/redux/ModuleLoaderLazy';

export interface Props {
  deviation: PapiDeviation;
  subscriberConnect: (deviation: PapiDeviation) => void;
}

const ConnectDiscord: React.FC<Props> = ({ deviation, subscriberConnect }) => {
  const { t } = useTranslation();

  if (!deviation.tier?.discord?.connected) {
    // The tier author hasn't connected their discord server
    return null;
  }

  if (deviation.tier?.discord?.oauth2) {
    return (
      <Suspense fallback={null}>
        <DiscordModuleLoaderLazy />
        <ListItemButton
          label={t('deviationview.tierCard.moreActionsMenu.item.connectDiscord')}
          onClick={() => subscriberConnect(deviation)}
          biData={BiData<SubscriberConnectToDiscordClickBiEvent>({
            evid: 555,
            itemid: deviation.deviationId,
          })}
          fillContainerWidth
        />
      </Suspense>
    );
  }

  return null;
};
ConnectDiscord.displayName = 'ConnectDiscord';

export default ConnectDiscord;
